import React, { Fragment, FunctionComponent } from 'react';
import { CustomArticleSlugTypes } from 'types/global';
import { Description, Features, HeroImageTop, HeroSimple, People, Technologies } from 'components/containers';
import { PageWrapper } from 'components/presentional';
import { usePages } from 'hooks';
import { useRouteTranslations } from 'utils';
import { WPAcfAboutUs, WPAcfGlobalPage } from 'types/acf';
import { WPSimplePage } from 'types/pages';

interface OwnProps {
  global?: WPSimplePage<WPAcfGlobalPage>;
}

type AboutUsPageProps = Omit<JSX.IntrinsicElements['article'], 'children'> & OwnProps;

const AboutUsPage: FunctionComponent<AboutUsPageProps> = props => {
  const ABOUT_US_PAGE_SLUG_TYPE: CustomArticleSlugTypes = 'about_us';

  const { translateSlug } = useRouteTranslations();
  const { data: page, loading } = usePages<WPSimplePage<WPAcfAboutUs>>({ slug: translateSlug(ABOUT_US_PAGE_SLUG_TYPE) });

  const [customPage] = page || [];

  const renderContent = (page: WPSimplePage<WPAcfAboutUs>) => {
    const {
      acf: { heroImageTop, descriptionBlock, heroSimple, features, people, technologies },
    } = page || {};

    return (
      <Fragment>
        {heroImageTop && <HeroImageTop data={heroImageTop} />}
        {descriptionBlock && <Description data={descriptionBlock} />}
        {heroSimple && <HeroSimple data={heroSimple} />}
        {features && <Features data={features} />}
        {people && <People data={people} />}
        {technologies && <Technologies data={technologies} />}
      </Fragment>
    );
  };

  return (
    <PageWrapper title={customPage?.yoast_title} meta={customPage?.yoast_meta} loading={loading} name={ABOUT_US_PAGE_SLUG_TYPE}>
      {page && customPage && renderContent(customPage)}
    </PageWrapper>
  );
};

export default AboutUsPage;
